export default class LineItem {
  constructor (lineItemCost, lineItemDescription, lineItemType) {
    this.lineItemCost = lineItemCost
    this.lineItemDescription = lineItemDescription
    this.lineItemType = lineItemType
  }
}

LineItem.Types = { MEET_AND_GREET: 'meet_and_greet', TOTAL: 'total' }



// WEBPACK FOOTER //
// ./src/models/line_item.js